<template>
<div id="card-details">
    <div id="infotitulo">
        <p class="title"><i class="pl-3 fas fa-clipboard-list"> </i> RESUMO</p>
    </div>
    <div class="card-details-body mt-4 ml-3">
        <p class="mb-4" id="label-result-name">{{selectedComissao.empreendimento.nome}}</p>

        <p class="label-details ">Status  </p>
        <div id="circle" >
        <p class="result-status" :style='statusColor'> {{statusText}} </p> </div>

        <p class="label-details">Corretor</p>
        <p class="result-details">{{selectedComissao.conta.nome}}</p>

        <p class="label-details">Valor Total da Comissão</p>
        <p class="result-details">{{selectedComissao.valorTotalComissaoFormatado}}</p>

        <p class="label-details">Porcentagem Comissão</p>
        <p class="result-details"> {{selectedComissao.credenciada.percentualComissao}}%</p>
        <p class="label-details">Valor Mensal</p>
        <p class="result-details">{{selectedComissao.valorParcelaFormatada}}</p>
    </div>
</div>
</template>

<script>
import PanelcommissionAdm from './panelcommissionAdm'
export default PanelcommissionAdm
</script>

<style scoped>
@media (min-width: 800px ) and (max-width: 1400px) {
  #label-result-name{
      color: #5a5a5a;
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
      font-family: Segoe UI;
  }
}

@media (min-width: 1401px ){
  #label-result-name{
    color: #5a5a5a;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
}
.icone{
    font-size: 20px !important;
}
.title{
    font-size: 18px;
}
.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}
.label-details{
    font: normal normal normal 16px/21px Segoe UI;
    color: #666;
    text-align: left;
    margin: 0;
    font-weight: 700;
}
.result-details{
    font-size: 15px;
    color: #2a2a2a;
}
.result-status{
    display:table;
    padding:5px;
    padding-left: 20px;
    padding-right: 20px;
    font-size:15px;
    width: fit-content;
    color: white;
    border-radius: 16px;
    padding: 5px 20px;

}

#card-details{
    width: 100%;
    height: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}
.footer-card-details{
    font-size: 28px;
    font-weight: bold;
    color: #4F4C4D;
    line-height: 100%;
}

#infotitulo{
    height: 50px;
    width: 100%;
    font-size: 20px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissions/components/panelcommissionAdm/panelcommissionAdm.vue